export enum CLASSNAME_EDITOR_VIEW {
    DEFAULT = 'default',
    PLAIN = 'plain',
}

export enum CLASSNAME_EDITOR_MODE {
    EDIT = 'edit',
    CREATE = 'create',
}
